module.exports = __webpack_public_path__ + "static/media/accutrainee-icon.5c7b6897.svg";